import React from "react";

import WebcamViewer from "@Features/webcamViewer";

const WebcamViewerPage = () => {
    return <WebcamViewer />;
};
export default WebcamViewerPage;
